import useStore from '../../../../../../../../hooks/useStore';
import { VentilasjonsType } from '../../../../../../../../components/registering/utils/registerEnums';

// "Ventilasjon varmebatteri" should only be visible if "Balansert ventilasjon" is selected as "Type ventilasjonssystem"
// in "Ventilasjon" form.
export const useVentilasjonsData = () => {
  const store = useStore();
  const ventilasjonType = store.getState().register.userInput?.ventilasjon?.ventilasjonType;

  const hasBalansertVentilasjon = ventilasjonType === VentilasjonsType.Balansert;

  return { hasBalansertVentilasjon };
};
